import { useNavigate } from "react-router-dom";
import {
  Box,
  Tab,
  Tabs,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Select,
  MenuItem,
  Chip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  useDeletePasswordMutation,
  useLazyGetPasswordQuery,
  useUpdatePasswordMutation,
} from "../../services/resetPassword";
import moment from "moment";
import { showError, showToast } from "../../constants/toasts";
import IfCan from "../../components/IfCan";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ResetPasswordRequests = () => {
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const navigate = useNavigate();
  const [getData] = useLazyGetPasswordQuery();
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [data, setData] = useState<any[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [UpdateStatus] = useUpdatePasswordMutation();
  const totalPages = Math.ceil(totalCount / 10);

  const PASSWORD_STATUS = {
    PENDING: 1,
    ACCEPTED: 2,
  } as const;

  const getPasswordList = async () => {
    setIsLoading(true);
    try {
      const response = await getData({
        search: debouncedSearchTerm,
        start: page,
        length: 10,
        status:
          valueTabs === 0 ? PASSWORD_STATUS.PENDING : PASSWORD_STATUS.ACCEPTED,
      }).unwrap();

      if (response?.status === 200) {
        setData(response?.data?.response_object);
        setRows(response?.data?.response_object || []);
        setTotalCount(response?.data?.total_records || 0);
      } else {
        setData([]);
        setRows(response?.data?.response_object || []);
        setTotalCount(0);
      }
    } catch (error) {
      console.log(error);
      setData([]);
      setTotalCount(0);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getPasswordList();
  }, [page, debouncedSearchTerm, valueTabs]);

  const [rows, setRows] = React.useState<any[]>([]);

  const handleStatusChange = async (id: number, status: number) => {
    try {
      await UpdateStatus({ id, body: { request_status: status } }).unwrap();
      showToast("Status updated successfully");
      setRows((prev) =>
        prev.map((r) => (r.id === id ? { ...r, request_status: status } : r))
      );
    } catch (e: any) {
      showError(e?.data?.message || "Failed to update status");
    }
  };

  const filteredRows = rows.filter((r) =>
    valueTabs === 0
      ? r.request_status === PASSWORD_STATUS.PENDING
      : r.request_status === PASSWORD_STATUS.ACCEPTED
  );

  return (
    <>
      <IfCan module="Settings" action="view">
        <div className="main_title">
          <h1>Reset Password Requests</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
            Reset Password Requests
          </p>
        </div>
        <Box className="custom_tabs1" sx={{ width: "100%" }}>
          <Tabs
            value={valueTabs}
            onChange={handleChangeTabs}
            aria-label="basic tabs example"
            className="custom_tabs_links"
          >
            <Tab label="Pending" {...a11yProps(0)} />
            <Tab label="Accepted" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <div className="cards">
          <CustomTabPanel value={valueTabs} index={0}>
            <TableContainer className="table_container">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>User Email</TableCell>
                    {/* <TableCell>Password</TableCell> */}
                    <TableCell>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredRows.length === 0 ? (
                    <TableRow>
                      <TableCell
                        colSpan={2}
                        style={{ textAlign: "center", padding: "20px" }}
                      >
                        No requests found
                      </TableCell>
                    </TableRow>
                  ) : (
                    filteredRows.map((row) => (
                      <TableRow hover key={row.id}>
                        <TableCell>{row?.user?.email || "-"}</TableCell>
                        {/* <TableCell>{row?.password || '-'}</TableCell> */}
                        <TableCell>
                          {row.request_status === PASSWORD_STATUS.ACCEPTED ? (
                            <Chip
                              label="Accepted"
                              color="success"
                              size="small"
                            />
                          ) : (
                            <IfCan
                              module="Settings"
                              action="add_edit"
                              fallback={<Chip label="Pending" size="small" />}
                            >
                              <Select
                                value={row.request_status}
                                size="small"
                                onChange={(e) =>
                                  handleStatusChange(
                                    row.id,
                                    Number(e.target.value)
                                  )
                                }
                                sx={{
                                  minWidth: 120,
                                  ".MuiSelect-select": {
                                    paddingTop: 0.5,
                                    paddingBottom: 0.5,
                                    paddingLeft: 1,
                                    paddingRight: 1,
                                    fontSize: 12,
                                  },
                                }}
                              >
                                <MenuItem
                                  value={PASSWORD_STATUS.PENDING}
                                  sx={{ fontSize: 12 }}
                                >
                                  Pending
                                </MenuItem>
                                <MenuItem
                                  value={PASSWORD_STATUS.ACCEPTED}
                                  sx={{ fontSize: 12 }}
                                >
                                  Accepted
                                </MenuItem>
                              </Select>
                            </IfCan>
                          )}
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={1}>
            <TableContainer className="table_container">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>User Email</TableCell>
                    {/* <TableCell>Password</TableCell> */}
                    <TableCell>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredRows.length === 0 ? (
                    <TableRow>
                      <TableCell
                        colSpan={2}
                        style={{ textAlign: "center", padding: "20px" }}
                      >
                        No requests found
                      </TableCell>
                    </TableRow>
                  ) : (
                    filteredRows.map((row) => (
                      <TableRow hover key={row.id}>
                        <TableCell>{row?.user?.email || "-"}</TableCell>
                        {/* <TableCell>{row?.password || '-'}</TableCell> */}
                        <TableCell>
                          {row.request_status === PASSWORD_STATUS.ACCEPTED ? (
                            <Chip
                              label="Accepted"
                              color="success"
                              size="small"
                            />
                          ) : (
                            <IfCan
                              module="Settings"
                              action="add_edit"
                              fallback={<Chip label="Pending" size="small" />}
                            >
                              <Select
                                value={row.request_status}
                                size="small"
                                onChange={(e) =>
                                  handleStatusChange(
                                    row.id,
                                    Number(e.target.value)
                                  )
                                }
                                sx={{
                                  minWidth: 120,
                                  ".MuiSelect-select": {
                                    paddingTop: 0.5,
                                    paddingBottom: 0.5,
                                    paddingLeft: 1,
                                    paddingRight: 1,
                                    fontSize: 12,
                                  },
                                }}
                              >
                                <MenuItem
                                  value={PASSWORD_STATUS.PENDING}
                                  sx={{ fontSize: 12 }}
                                >
                                  Pending
                                </MenuItem>
                                <MenuItem
                                  value={PASSWORD_STATUS.ACCEPTED}
                                  sx={{ fontSize: 12 }}
                                >
                                  Accepted
                                </MenuItem>
                              </Select>
                            </IfCan>
                          )}
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </CustomTabPanel>
        </div>
      </IfCan>
    </>
  );
};

export default ResetPasswordRequests;
